// extracted by mini-css-extract-plugin
export default {"content":"Project_content__t-fdk","links":"Project_links__FILwX","technologies":"Project_technologies__LQdse"};